'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[ShoppingTabs]');

var WinresReservationShoppingTabsController = function () {
    function WinresReservationShoppingTabsController($scope, $document, $timeout, productService, localizationService, $location, $filter) {
        _classCallCheck(this, WinresReservationShoppingTabsController);

        this.$document = $document;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$location = $location;
        this.productService = productService;
        this.localizationService = localizationService;
        this.extraServiceAmount = 0;
        this.extraBusServiceAmount = 0;
        this.hasServices = false;
        this.hasBusRoutes = false;
        // this.busProducts = [];
        this.$filter = $filter;
    }

    _createClass(WinresReservationShoppingTabsController, [{
        key: 'findServiceAmount',
        value: function findServiceAmount(service) {
            var amount = 0;
            _.each(this.data.Products, function (p) {
                if (service.StartDate == p.Product.StartDate && service.EndDate == p.Product.EndDate && service.DestinationInfo.ProductCode == p.Product.DestinationInfo.ProductCode && service.DestinationInfo.DestinationCode == p.Product.DestinationInfo.DestinationCode) {
                    amount = p.Amount;
                }
            });
            return amount;
        }
    }, {
        key: 'updateSC',
        value: function updateSC(searchCriteria) {
            log('Search criteria:', searchCriteria);
            this.searchCriteria = searchCriteria;
        }
    }, {
        key: 'updatePassengers',
        value: function updatePassengers(response) {
            if (this.data.NumAdults != response.NumAdults) {
                this.data.NumAdults = response.NumAdults;
                this.data.Passengers.push({ Gender: "MR", IsOpen: true });
            }
            if (this.data.NumChildren != response.NumChildren) {
                this.data.NumChildren = response.NumChildren;
                this.data.Passengers.push({ Gender: "MR", IsOpen: true });
            }
            if (this.data.NumInfants != response.NumInfants) {
                this.data.NumInfants = response.NumInfants;
                this.data.Passengers.push({ Gender: "MR", IsOpen: true });
            }
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getContext().Passengers
            // getContext().NumAdults
            // getContext().NumChildren
            // getContext().NumInfants
            // getContext().Products
            // getContext().SelectedDeparture
            // getContext().DestinationCode
            // getCurrentPhase()
            // showBasketPopup
            // findProductLineByProduct()
            // getCurrentPhase()

            // Set:
            // setCurrentPhase()

            this.data = this.winresReservationContext.getContext();
            this.$scope.$watch(function () {
                return _this.searchCriteria;
            }, function (response) {
                if (response != undefined) {
                    _this.updatePassengers(response);
                    var groups = _.filter(_.map(_.split(_this.groups, ','), _.trim), function (s) {
                        return s !== '';
                    });

                    if (groups.length == 0) {
                        groups = null;
                    }

                    // Fetch extra services available on that departure
                    // (grouped by their linking group set in LinkingInfo)
                    _this.fetchGetReservableProductsGrouped(groups, _this.searchCriteria);
                }
            });
            // Automatically scroll when paid in bank.
            this.$scope.$watch(function () {
                return _this.winresReservationContext.getCurrentPhase();
            }, function (phase) {
                if (phase === 'thankyou') {
                    _this.goToPhase('thankyou');
                }
            });

            this.$scope.$watch(function () {
                return _this.winresReservationContext.showBasketPopup;
            }, function () {
                if (_this.winresReservationContext.showBasketPopup == 'visible') {
                    if (_this.basketPopupFading) _this.$timeout.cancel(_this.basketPopupFading);
                    if (_this.basketPopupHide) _this.$timeout.cancel(_this.basketPopupHide);

                    _this.basketPopupFading = _this.$timeout(function () {
                        _this.winresReservationContext.showBasketPopup = 'fading';
                        _this.basketPopupHide = _this.$timeout(function () {
                            _this.winresReservationContext.showBasketPopup = '';
                        }, 2000);
                    }, 2000);
                }
            });

            if (this.errorTimeout != null) {
                if (this.errorTimeout.length === 0) this.errorTimeout = 1;
                if (this.error) this.$timeout.cancel(this.error);
                if (this.hideError) this.$timeout.cancel(this.hideError);
                this.error = this.$timeout(function () {
                    if (_this.showErrors !== 'hidden') {
                        _this.showErrors = 'fading';
                        _this.hideError = _this.$timeout(function () {
                            _this.showErrors = 'hidden';
                            if (_this.location == 'bottom-error') {
                                _this.errorLocation = 'top-error';
                            }
                        }, 5000);
                    }
                }, this.errorTimeout);
            }

            this.$scope.$watch('$ctrl.data.SelectedDeparture', function () {
                if (_this.data.SelectedDeparture) {
                    var groups = _.filter(_.map(_.split(_this.groups, ','), _.trim), function (s) {
                        return s !== '';
                    });

                    if (groups.length == 0) {
                        groups = null;
                    }

                    // Fetch extra services available on that departure
                    // (grouped by their linking group set in LinkingInfo)
                    _this.fetchGetReservableProductsGrouped(groups, _this.data);

                    // Run the blocker check to set the blockerCheck promise.
                    _this.winresReservationContext.checkBlockers();
                }
            });

            this.$scope.singlePersonAndNoSinglePrice = _.every(this.data.Products, function (p) {
                return p.HasSinglePassengerPrice == false;
            }) && this.data.NumAdults + this.data.NumChildren === 1;

            if (this.extraServicesTitle) this.$scope.extraServicesTitle = this.extraServicesTitle;else this.$scope.extraServicesTitle = this.$filter('i18next')('reservation_customer.extra_services');

            // Watch broadcasts. Used to show extra service tab and to change tab width.
            // winresServices -> hasServices
            // winresTransport -> hasBusRoutes
            this.watchServicesAndBusRoutes();

            if (!this.numOfPeopleLimit) {
                this.numOfPeopleLimit = 10;
            }
        }
    }, {
        key: 'fetchGetReservableProductsGrouped',
        value: function fetchGetReservableProductsGrouped(groups, data) {
            var _this2 = this;

            this.productService.getReservableProductsGrouped({
                DestinationCode: this.data.DestinationCode,
                StartDate: this.data.SelectedDeparture.DepartureDate,
                EndDate: this.data.SelectedDeparture.ArrivalDate2,
                MinCapacity: data.NumAdults,
                GroupIDs: groups,
                ProductType: 'common'
            }, this.localizationService.getLanguage()).then(function (productGroups) {
                _.each(_this2.data.Products, function (p) {
                    if (!p.Amount) {
                        p.Amount = 0;
                    }
                });
                _this2.productGroups = [];
                _.each(productGroups, function (group, index) {
                    // The result is an array, if groups 0 and 2 are set,
                    // 1 might be undefined (since arrays are not sparse
                    // in Javascript)
                    if (!group || group.length == 0) {
                        return;
                    }

                    var object = {
                        Unpicked: data.NumAdults,
                        PickedTooMany: 0,
                        Products: group,
                        Index: index,
                        Min: group[0].LinkingInfo ? group[0].LinkingInfo.Minimum : 1,
                        Max: group[0].LinkingInfo ? group[0].LinkingInfo.Maximum : 1
                    };

                    if (object.Min == null || object.Min <= 0) {
                        if (group[0].LinkingInfo.ForcingMode == 'Forced') {
                            object.Min = 1;
                        } else {
                            object.Min = 0;
                        }
                    }

                    if (object.Max == null || object.Max <= 0) {
                        object.Max = 1;
                    }

                    _this2.productGroups.push(object);
                    _.each(group, function (product) {
                        if (!product.Amount) {
                            product.Amount = _this2.findServiceAmount(product);
                        }

                        if (_this2.assignPassengers == "false") {
                            _this2.$scope.$watch(function () {
                                return product.Amount;
                            }, function (num) {
                                var productLine = _this2.winresReservationContext.findProductLineByProduct(product);
                                if (!productLine) {
                                    productLine = {
                                        Amount: num,
                                        Product: product,
                                        PassengerAssignments: []
                                    };
                                    _this2.data.Products.push(productLine);
                                }
                                productLine.Amount = num;
                                productLine.UnitProce = product.Price;
                                productLine.TotalPrice = productLine.Amount * product.Price;
                                _this2.validate();
                            });
                        } else {
                            product.PassengerCounts = [];
                            var productLine = _this2.winresReservationContext.findProductLineByProduct(product);
                            if (productLine) {
                                _this2.$scope.$watch(function () {
                                    return productLine.PassengerAssignments;
                                }, function () {
                                    return _this2.updateAmounts(productLine);
                                }, true);
                            }
                            _this2.$scope.$watch(function () {
                                return product.PassengerCounts;
                            }, function () {
                                //this.updateAssignments(product);
                                //this.updateProductPrice(product);
                                //this.validate();
                            }, true);
                        }
                    });
                });

                _this2.updatePassengerPrices();
                //this.updateNonGroupForcings();
            });
        }
    }, {
        key: 'findProduct',
        value: function findProduct(productLine) {
            // NOTE: Cannot just return productLine.Product - it needs to be the
            // same object instance that is loaded fro backend. If the page is
            // reloaded, the data in session might be used, which would be
            // JSON-decoded and have a different object instalce for Product.
            var result = null;
            _.each(this.productGroups, function (group) {
                _.each(group.Products, function (product) {
                    if (product.StartDate == productLine.Product.StartDate && product.EndDate == productLine.Product.EndDate && product.DestinationInfo.ProductCode == productLine.Product.DestinationInfo.ProductCode && product.DestinationInfo.DestinationCode == productLine.Product.DestinationInfo.DestinationCode) {
                        result = product;
                    }
                });
            });
            return result;
        }
    }, {
        key: 'updateAmounts',
        value: function updateAmounts(productLine) {
            if (!productLine || !productLine.PassengerAssignments) {
                // Product doesn't have passenger assignments.
                // Previously, this function tried to check the non-existent
                // PassengerAssignments of a per-booking product.
                return;
            }

            var product = this.findProduct(productLine);
            if (!product) {
                // Products have not been loaded yet.
                return;
            }
            var numPassengers = this.data.NumAdults + this.data.NumChildren + this.data.NumInfants;
            // Avoid replacing passengerCounts, since otherwise this might end
            // in an infinite digest loop. Also, $watch would stop working since
            // it watches the array object.
            product.PassengerCounts.length = numPassengers;
            _.fill(product.PassengerCounts, 0);
            _.each(productLine.PassengerAssignments, function (assignment) {
                if (!product.PassengerCounts[assignment.PassengerNumber]) {
                    product.PassengerCounts[assignment.PassengerNumber] = 0;
                }
                product.PassengerCounts[assignment.PassengerNumber]++;
            });
            productLine.Amount = product.Amount = _.sum(product.PassengerCounts);
            if (productLine.Amount == 0) {
                _.pull(this.data.Products, productLine);
            }
        }

        // returns class name that can be used to display current state of order.
        // blocksState is the state that is active for that block.
        // states is array of all states in order.
        // SG: departure -> accommodation -> passenger -> extraservices

    }, {
        key: 'getClassName',
        value: function getClassName(blocksState, states) {
            //made for SG
            if (blocksState == "pplNum") {
                if (this.winresReservationContext.getCurrentPhase() == "departure") {
                    return "block-not-done";
                } else {
                    return "block-done";
                }
            }
            if (blocksState == this.winresReservationContext.getCurrentPhase()) {
                return "block-active";
            } else if (states.indexOf(blocksState) < states.indexOf(this.winresReservationContext.getCurrentPhase())) {
                return "block-done";
            } else {
                return "block-not-done";
            }
        }
    }, {
        key: 'isCapacityBoolean',
        value: function isCapacityBoolean() {
            /*if(this.hideWhenNoCapacity === 'true' && this.data.SelectedDeparture != null){
                return this.getTotalPeople() <= this.data.SelectedDeparture.CapacityAvailable;
            }else{
                return true;
            }*/
            return true;
        }
    }, {
        key: 'getTotalPeople',
        value: function getTotalPeople() {
            return this.data.NumAdults + this.data.NumChildren + this.data.NumInfants;
        }

        //returns balloon that this state is not done

    }, {
        key: 'getEmptyText',
        value: function getEmptyText(balloonText, btnText) {
            return;
        }
    }, {
        key: 'getFlatProducts',
        value: function getFlatProducts() {
            return _.flatten(_.map(this.productGroups, function (group) {
                return group.Products;
            }));
        }
    }, {
        key: 'getBusProducts',
        value: function getBusProducts(DestinationCode) {
            return this.productService.getBusRoutesByDestinationCode(DestinationCode);
        }
    }, {
        key: 'updatePassengerPrices',
        value: function updatePassengerPrices() {
            var _this3 = this;

            // Calculate per-passenger prices (backend handles this.)
            // Make a product line for each product / passenger -combo
            // (for extra services, the whole product row price is the sum of all
            //  individual passengers' prices. This does not hold for
            //  accommodations.)
            var products = this.getFlatProducts();

            var productLines = _.flatMap(products, function (product) {
                var result = [];
                for (var i = 0; i < _this3.data.Passengers.length; ++i) {
                    result.push({
                        Amount: 1,
                        Product: product,
                        PassengerAssignments: [{
                            ProductNumber: 1,
                            PassengerNumber: i
                        }]
                    });
                }

                return result;
            });
            _.each(products, function (product) {
                product.PassengerPrices = [];
            });

            /*var productsWithoutHiddenProducts = _.filter(function(prod) {
                return prod.LinkingInfo.ForcingMode !== "Hidden";
            });*/

            var productsWithoutHiddenProducts = _.filter(productLines, function (prod) {
                if (prod.Product.LinkingInfo !== true || prod.Product.LinkingInfo.ForcingMode !== "Hidden") {
                    return true;
                }
            });

            //this.extraServiceAmount = productsWithoutHiddenProducts.length;
            // log("this.data.Products:", this.data.Products);

            var destinationCode = "";
            if (this.data.Products[0]) // Pick destination code from first product if exist.
                destinationCode = this.data.Products[0].Product.DestinationInfo.DestinationCode;else {
                // Else pick destination code from SelectedDeparture.
                destinationCode = this.data.SelectedDeparture.DestinationCode;
                // log.warn("updatePassengerPrices: this.data.Products[0] is null, using SelectedDeparture DestinationCode");
            }
            // log("updatePassengerPrices: DestinationCode is", destinationCode);

            // Extra service tab visibility and tab width.
            // Exists for backwards compatibility.
            // TODO: Remove.
            this.getBusProducts(destinationCode).then(function (response) {
                _this3.extraServiceAmount += productsWithoutHiddenProducts.length;
                _this3.busProducts = response;
                if (_this3.busProducts.Routes.length > 0) {
                    // Old.
                    _this3.extraServiceAmount += 1;
                    _this3.extraBusServiceAmount += 1;

                    // New.
                    _this3.hasServices = true;
                    _this3.hasBusRoutes = true;
                }
            }, function (err) {
                _this3.extraServiceAmount = productsWithoutHiddenProducts.length;
                log.warn("getBusProducts failed:", err);
            });
        }

        // Called by shopping cart buttons
        // (TODO: Make them call reservationContext directly)

    }, {
        key: 'goToPhase',
        value: function goToPhase(phase) {
            // this.winresReservationContext.phase = this.actualTargetPhase; //
            this.winresReservationContext.setCurrentPhase(phase, true);
        }
    }, {
        key: 'shouldHideForSinglePassenger',
        value: function shouldHideForSinglePassenger() {
            var totalPeopleAmount = this.getTotalPeople();
            var hasSinglePassengerPrice = null;
        }
    }, {
        key: 'watchServicesAndBusRoutes',
        value: function watchServicesAndBusRoutes() {
            var _this4 = this;

            // Broadcast from winresServices.
            this.$scope.$on('hasServices', function (event, value) {
                _this4.hasServices = _this4.hasServices || true;
            });

            // Broadcast from winresTransport.
            this.$scope.$on('hasBusRoutes', function (event, value) {
                _this4.hasBusRoutes = _this4.hasBusRoutes || true;
            });
        }
    }]);

    return WinresReservationShoppingTabsController;
}();

WinresReservationShoppingTabsController.$inject = ['$scope', '$document', '$timeout', 'productService', 'localizationService', '$location', '$filter'];

function getTemplate($attrs, $sce) {
    if ($attrs.wrapperMode == null && $attrs.templateUrl == null) {
        return 'winresReservationShoppingTabs';
    }
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'winresReservationShoppingTabs' + $attrs.wrapperMode;
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('winresReservationShoppingTabs', require('./winresReservationShoppingTabs.html'));
    $templateCache.put('winresReservationShoppingTabsWrapper', require('./winresReservationShoppingTabsWrapper.html'));
}]);

_module3.default.component('winresReservationShoppingTabs', {
    templateUrl: getTemplate,
    controller: WinresReservationShoppingTabsController,
    bindings: {
        showErrors: '@', // true / false (default=false). If true, when payment
        // button is clicked, errors are shown on the shopping
        // cart.
        // if empty: uses the default way of building shopping cart. If "Wrapper": has all the elements automatically included in the template.
        wrapperMode: '@',

        // default: false;
        hideWhenNoCapacity: '@',

        // extra services title
        extraServicesTitle: '@',

        // Show departure flight schedule. false / true.
        flightSchedule: '@',

        // Show num of adults +/- in num of people select. Is shown by default. false to hide.
        showNumOfAdults: '@',

        // Show num of children +/- in num of people select. Is shown by default. false to hide.
        showNumOfChildren: '@',

        // Show num of infants +/- in num of people select. Is shown by default. false to hide.
        showNumOfInfants: '@',

        // Num of people limit.
        numOfPeopleLimit: '@'
    },
    require: {
        winresReservationContext: '^^winresReservationContext'
    },
    transclude: {
        'winresReservationShoppingTabsItems': '?winresReservationShoppingTabsItems'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationShoppingTabs/winresReservationShoppingTabs.js
// module id = 390
// module chunks = 2